import '../styles/header.css'
import React from 'react';

import constants from '../constants';

class HeaderComponent extends React.Component {

    render = () => {
        return (
            <div className="header-container">
                <div className='header'>
                    <div className='logos-container'>
                        <a className='logo-container' href='https://ffsl.utah.gov/' target='_blank' rel="noreferrer"><img src={constants.FFSLLogoUrl} alt='Utah DNR - FFSL Logo' /></a>
                        <a className='logo-secondary-container' href='https://dem.utah.gov/' target='_blank' rel="noreferrer"><img src={constants.DEMLogoUrl} alt='Department of Public Safety Division of Emergency Management Logo' /></a>
                        <a className='logo-third-container' href='https://extension.usu.edu/Post-Wildfire/' target='_blank' rel="noreferrer"><img src={constants.USULogoUrl} alt='Department of Public Safety Division of Emergency Management Logo' /></a>
                        <div className='banner-flare'>
                            <img src="/banner-flare.svg" alt="banner-flare" />
                        </div>
                    </div>
                    <div className='header-content'>
                        <div className='header-title'>
                            <h1 className='Oswald' >{constants.appName}</h1>
                            <h2 className={constants.subtitle && constants.subtitle.length ? '' : 'hidden'}>{constants.subtitle}</h2>
                        </div>
                    </div>
                    <div className='header-actions'>
                        <button className='button primary no-print' onClick={this.props.openAbout} >About This Tool</button>
                    </div>
                </div>
            </div>
        )
    }
}


export default HeaderComponent;